import PropTypes from 'prop-types';

// Utils
import { cn } from 'utils';

import styles from './Tag.module.css';

function Tag({
  content, color, outlined, weight,
}) {
  return (
    <div className={cn([
      styles.tag,
      color ? styles[color] : '',
      outlined && styles.outlined,
      styles[weight],
    ])}
    >
      {content}
    </div>
  );
}

Tag.propTypes = {
  content: PropTypes.node.isRequired,
  color: PropTypes.oneOf(['primary', 'black', 'red', 'white']),
  weight: PropTypes.oneOf(['light', 'bold']),
  outlined: PropTypes.bool,
};

Tag.defaultProps = {
  color: 'primary',
  outlined: false,
  weight: 'bold',
};

export default Tag;
